import React from 'react';

interface CardHeaderProps {
  children: React.ReactNode;
  className?: string;
}

export default function CardHeader({
  children,
  className = '',
}: CardHeaderProps) {
  return (
    <>
      <div className={`px-6 py-2 ${className}`}>
        <h2 className="text-gray-300 flex justify-between uppercase">
          {children}
        </h2>
      </div>
      <hr className={`w-full h-[0.5px] bg-neutral-200  ${className}`} />
    </>
  );
}
